module.exports = __webpack_public_path__ + "static/media/manager-r-5.d1eda86c.png";